import { GetServerSideProps } from 'next'

import { serverSidePropsFor } from '@/utils/helpers.server'

import CommandersPage from '../commanders'

export const getServerSideProps: GetServerSideProps = async ({ query, req }) => {
  const slug = Array.isArray(query.slug) ? query.slug.join('/') : query.slug
  return serverSidePropsFor(`${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/cards/${slug}.json`, req.headers)
}

export default CommandersPage
